import { render } from "./role.vue?vue&type=template&id=fc5c855c"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__